var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"transition","appear":""}},[(_vm.show)?_c('div',{directives:[{name:"append-body",rawName:"v-append-body"}],style:(_vm.cssStyle)},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }